module.exports = __webpack_public_path__ + "img/tools.85d8f687.svg";